import styled from "styled-components";

export const FileContainer = styled.div`
  display: flex;
  padding: 10px;
  margin-left: 20px
`;